import React from 'react';
import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
import { SkeletonRegistryItem } from '../../../registry/skeleton/SkeletonRegistryItem';
import { Actor_ } from '../../../components/actor/Actor_';
import { Aspect_ } from '../../../components/actor/Aspect_';
export class SkeletonsCycleEnd extends SkeletonRegistryCategory {
    label = 'Question CycleEnd';
    constructor(parent) {
        super(parent);
        super.init();
    }
    cycleEndStruct_default = () => new SkeletonRegistryItem({
        label: 'Default CycleEnd Structure',
        jsx: ({ question }) => {
            if (!question)
                return null;
            const question_ = question;
            return (React.createElement(Aspect_, { aspect: question_.inner },
                React.createElement(Actor_, { actor: question_.reward })));
        }
    });
}
